module.exports = __webpack_public_path__ + "img/vertical_3_1_7016.34013ec3.png";